<template>
  <toggle-button-group :options="directionOptions" @change="handleChange" />
</template>

<script>
import toggleButtonGroup from '../../../toggleButton/toggleButtonGroup.vue';

export default {
  name: 'OtpDirectionFilter',
  components: {
    toggleButtonGroup,
  },
  props: {
    selectedDirection: {
      type: String,
      default: 'all',
    },
    selectedWorkingType: {
      type: String,
      default: 'All',
    },
  },
  computed: {
    directionOptions() {
      let directions = [
        { label: this.$t('flexigo.otp.allDirections'), value: 'all' },
        { label: this.$t('flexigo.otp.inbound'), value: 'inbound' },
        { label: this.$t('flexigo.otp.outbound'), value: 'outbound' },
        { label: this.$t('flexigo.otp.loop'), value: 'loop' },
      ];

      // Filter out LOOP when Dynamic is selected
      if (this.selectedWorkingType === 'Dynamic') {
        directions = directions.filter((dir) => dir.value !== 'loop');
      }

      return directions.map((dir) => ({
        label: dir.label,
        selected: dir.value === this.selectedDirection,
      }));
    },
    availableDirections() {
      let directions = ['all', 'inbound', 'outbound', 'loop'];

      // Filter out LOOP when Dynamic is selected
      if (this.selectedWorkingType === 'Dynamic') {
        directions = directions.filter((dir) => dir !== 'loop');
      }

      return directions;
    },
  },
  methods: {
    handleChange({ index }) {
      this.$emit('change', this.availableDirections[index]);
    },
  },
};
</script>

<style scoped>
/* Styles handled by toggleButtonGroup component */
</style>
